import { useCallback } from 'react';

import TextInputNumericServerError from '@perpay-web/components/higher-order/WithFieldServerErrors/TextInputNumericServerError';

export const MoneyInput = ({
    name = 'pay',
    label = 'Pay',
    removeDecimals = false,
    allowNegative = false,
    placeholder = '500',
    prefix = '$',
    thousandSeparator = ',',
    ...rest
}) => {
    const format = useCallback(
        (value) => {
            if (removeDecimals) {
                return value.replace('.', '');
            }
            return value;
        },
        [removeDecimals],
    );

    return (
        <TextInputNumericServerError
            name={name}
            label={label}
            placeholder={placeholder}
            type='tel'
            format={format}
            prefix={prefix}
            decimalScale={removeDecimals ? 0 : 2}
            allowNegative={allowNegative}
            thousandSeparator={thousandSeparator}
            {...rest}
        />
    );
};
